import { TextInput, SelectInput, DateInput, BooleanInput } from 'react-admin';
import { INGEST_RUN_STATUSES } from '../../../../../helpers/adsIngestRunsConstants';

export const getAdsIngestRunsFilters = (summary) => [
  <SelectInput
    source="status"
    label="Status"
    choices={INGEST_RUN_STATUSES}
    alwaysOn
    className="input-width-md"
  />,
  <SelectInput
    source="internal_account_id"
    label="Account"
    choices={((summary && summary.bridges) || []).map((bridge) => ({
      id: bridge.internal_account_id,
      name: bridge.account_name
    }))}
    alwaysOn
    className="input-width-md"
  />,
  <SelectInput
    source="job_name"
    label="Job"
    choices={((summary && summary.job_names) || []).map((name) => ({ id: name, name }))}
    alwaysOn
    className="input-width-md"
  />,
  <DateInput source="received_from" label="Received from" alwaysOn />,
  <DateInput source="received_to" label="Received to" alwaysOn />,
  <TextInput source="script_run_id" label="Script run ID" />,
  <BooleanInput source="has_error" label="Has error" />
];
